"use client";
import {GoogleOAuthProvider} from "@react-oauth/google";
import Link from "next/link";
import {useTheme} from "next-themes";
import {useEffect, useState} from "react";

export default function AuthLayout({children}: {children: React.ReactNode}) {
  const {resolvedTheme} = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const logoSrc = resolvedTheme === "dark" ? "/rtzen-logo-dark.svg" : "/rtzen-logo.svg";

  return (
    <GoogleOAuthProvider clientId="170518624740-3shijsqa01sqr0lo2pv87pdqvmmkiq9r.apps.googleusercontent.com">
      <div className="bg-muted">
        {/* <div className="absolute top-4 right-4 z-20">
          <ModeToggle />
        </div> */}

        <div className="grid min-h-svh lg:grid-cols-1">
          {/* <LeftSection /> */}
          <div className="flex flex-col gap-4 p-6 md:p-4 w-full">
            <div className="flex justify-center gap-2 md:justify-start">
              <Link href="/" className="flex items-center gap-0.5 font-medium">
                {mounted && <img src={logoSrc} alt="rtZen logo" className="h-8 w-auto" />}
              </Link>
            </div>
            <div className="flex flex-1 items-center justify-center">
              <div className="w-full max-w-md">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}
